module.exports = __webpack_public_path__ + "media/img/features/audit-log-partial-9e0b73dc4713bb71ea3e3abb39cb1a62.png";